<template>
  <div class="is-pulled-right review-actions">
    <button v-if="result.isPending()|result.isNotOK()"
      @click="$emit('stateOK', result)"
      class="button check-pending is-outlined radius-circle is-success">
      <span class="icon is-medium">
        <i class="mdi mdi-check check-icon"></i>
      </span>
    </button>
    <button v-if="result.isOK()"
      @click="$emit('statePENDING', result)"
      class="button check-ok radius-circle is-success">
      <span class="icon is-medium">
        <i class="mdi mdi-check check-icon"></i>
      </span>
    </button>
    <button v-if="result.isPending()|result.isOK()"
      @click="$emit('stateNotOK', result)"
      class="button check is-outlined radius-circle is-danger">
      <span class="icon is-medium">
        <i class="mdi mdi-close check-icon"></i>
      </span>
    </button>
    <button v-if="result.isNotOK()"
      @click="$emit('statePENDING', result)"
      class="button check not-ok radius-circle is-danger">
      <span class="icon is-medium">
        <i class="mdi mdi-close check-icon"></i>
      </span>
    </button>
    <button @click="$emit('openCommentSection', result)"
      class="button is-outlined radius-circle is-gray">
      <span class="icon is-medium">
        <i v-if="result.comments.length" class="mdi mdi-comment-text-outline check-icon"></i>
        <i v-else class="mdi mdi-comment-outline check-icon"></i>
      </span>
    </button>
  </div>
</template>

<script>
  import { ReviewResult } from '@/classes/case/ReviewResult'

  export default {
    name: 'review-actions-component',
    props: {
      result: {
        type: ReviewResult,
        required: true
      }
    }
  }
</script>

<style lang="sass" scoped>
  .check-icon
    font-size: 1.3em !important
</style>
